import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { SessionService } from '../session/session.service';
import { Router } from '@angular/router';
import { AuthNavigationKeys, NavigationKeys } from '../../utils/navigationkeys';
@Injectable({
  providedIn: 'root',
})
export class CanActivateGuard implements CanActivate {
  constructor(
    private router: Router,
    private _sessionService: SessionService
  ) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (this._sessionService.isAuthLogged(state.url)) {
      return true;
    } else {
      this.router.navigate([NavigationKeys.LOGIN]);
      return false;
    }
    return true;
  }
}
